export default {
  timeRangeList: {
    ThreeMonths: '3 Months',
    SixMonths: '6 Months',
    OneYear: '1 Year',
  },
  topNewHighFooter:
    '*Top New High includes tickers that reach ceiling prices within %{time}',
  topNewLowFooter:
    '*Top New Low includes tickers that reach floor prices within %{time}',
};
